import styled from 'styled-components';
import * as TabsPrimitive from '@radix-ui/react-tabs';

export const TabsRoot = styled(TabsPrimitive.Root)`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const TabsContent = styled(TabsPrimitive.Content)`
  padding-top: 20px;
  flex: 1;
`;

export const TabsTrigger = styled(TabsPrimitive.Trigger)`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 1;
  padding: 12px 16px;
  background-color: transparent;
  color: #6b7280;
  border: none;
  border-radius: 0;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  border-bottom: 2px solid transparent;

  &:hover {
    color: #374151;
  }

  &[data-state="active"] {
    color: #3b82f6;
    font-weight: 600;
    border-bottom-color: #3b82f6;
  }

  &:focus-visible {
    outline: 2px solid #3b82f6;
    outline-offset: 2px;
  }
`;

export const TabsList = styled(TabsPrimitive.List)`
  display: inline-flex; 
  width: fit-content; 
  gap: 0;
  padding: 0;
  background-color: transparent;
  border-bottom: 1px solid #e5e7eb;
`;
